// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"d8b17192","4968":"4270de9e","6288":"b9dc2f68","8296":"1617e219","8775":"d9368b62","8829":"0dc1a2f8"}[chunkId] + ".chunk.css";
};